const FIELD_SELECT = {
  NO_OPTION_MESSAGE: 'No results found.',
};

export { FIELD_SELECT };
